import * as React from 'react';
export const IcEarPain = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M13 2C8.68 2 5.15 5.45 5.01 9.74L3.1 13.56a.993.993 0 00.45 1.34l1.45.72V17c0 1.1.9 2 2 2h2v1c0 1.1.9 2 2 2h5c1.1 0 2-.9 2-2v-3.76c1.83-1.47 3-3.72 3-6.24 0-4.41-3.59-8-8-8zm2.45 8.11c.29.14.49.42.54.73.05.32-.05.64-.28.87l-2 2c-.2.2-.45.29-.71.29-.26 0-.51-.1-.71-.29a.996.996 0 010-1.41l1.02-1.02-.76-.38a.99.99 0 01-.54-.73c-.05-.32.05-.64.28-.87l2-2a.996.996 0 111.41 1.41l-1.02 1.02.76.38h.01z'
      fill='currentColor'
    />
  </svg>
);
